import { render, staticRenderFns } from "./AddNewCustomer.vue?vue&type=template&id=1ac46cee&scoped=true"
import script from "./AddNewCustomer.vue?vue&type=script&lang=js"
export * from "./AddNewCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddNewCustomer.vue?vue&type=style&index=0&id=1ac46cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac46cee",
  null
  
)

export default component.exports